// What kind of key the browser holds. The legacy sign-in stores a session key (64 hex, core-backend
// Crypto.GenerateSalt); /sign-in stores a session JWT in the same place, and the app sends it wherever it sends
// the key (core-backend docs/auth_refactor.md §12). A JWT is three base64url parts and its header and payload are
// JSON objects, so both start with "eyJ". In cookie mode the JWT lives in an httpOnly cookie on the backend's host
// and the browser keeps only SESSION_COOKIE_KEY here; it is sent like the key, and the backend reads the cookie.
//
// No imports on purpose: scripts/verify-sign-in.mjs runs this file in plain Node.

const JWT = /^eyJ[A-Za-z0-9_-]*\.eyJ[A-Za-z0-9_-]*\.[A-Za-z0-9_-]+$/

/** What the browser keeps in cookie mode; core-backend SessionJwtCookie.KEY_PLACEHOLDER. Not a secret. */
export const SESSION_COOKIE_KEY = 'cubit-session-cookie'

/** True when the session JWT lives in the httpOnly cookie. */
export const isCookieKey = (key) => key === SESSION_COOKIE_KEY

/** True for a /sign-in session (a JWT, or the cookie placeholder), false for a legacy session key or anything else. */
export const isJwtKey = (key) => typeof key === 'string' && (isCookieKey(key) || JWT.test(key))

/**
 * Whether a request to this URL must send cookies: in cookie mode, and only to the backend's own origin. Every other
 * host (billing, the limited-restart slot, Koti) never sees the cookie.
 */
export const sendsSessionCookie = (url, backendUrl, key = storedSessionKey()) => {
    if (!isCookieKey(key) || !url || !backendUrl) return false
    try {
        return new URL(url, globalThis.location?.href).origin === new URL(backendUrl).origin
    } catch {
        return false
    }
}

/** The key the browser holds, or null outside a browser. */
export const storedSessionKey = () => {
    try {
        return typeof localStorage === 'undefined' ? null : localStorage.getItem('sessionKey')
    } catch {
        return null
    }
}
